import * as React from 'react'
import cn from 'clsx'

import { buttonStyle } from '../../utils/style'

type Props = {
  children: React.ReactNode
  disabled: boolean
  onClick?: () => void
  onMouseDown?: () => void
  className?: string
  type: 'submit' | 'button'
  tabIndex?: number
  outline?: boolean
} & React.ButtonHTMLAttributes<HTMLButtonElement>

export default function Button({
  children,
  disabled,
  onClick,
  onMouseDown,
  className,
  outline,
  tabIndex,
  type = 'button',
  ...rest
}: Props) {
  const extraProps: {
    onClick?: () => void
    onMouseDown?: () => void
    tabIndex?: number
  } = {}

  if (typeof onClick === 'function') {
    extraProps.onClick = onClick
  }

  if (typeof onMouseDown === 'function') {
    extraProps.onMouseDown = onMouseDown
  }

  if (typeof tabIndex === 'number') {
    extraProps.tabIndex = tabIndex
  }

  return (
    <button
      className={cn('button', className, { outline })}
      disabled={disabled}
      type={type}
      {...extraProps}
      {...rest}
    >
      {children}

      <style jsx>{buttonStyle}</style>
    </button>
  )
}
